import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { DEMSModule } from './pages/DEMSModule';
import { CRONModule } from './pages/CRONModule';
import { DataEnrichmentModule } from './pages/DataEnrichmentModule';
import { AuthProvider, useAuth } from './context/AuthContext';
const ProtectedRoute = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" data-id="element-0" />;
  }
  return <>{children}</>;
};
export function App() {
  return <AuthProvider data-id="element-1">
      <BrowserRouter data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
          <Route path="/dashboard" element={<ProtectedRoute data-id="element-7">
                <Dashboard data-id="element-8" />
              </ProtectedRoute>} data-id="element-6" />
          <Route path="/dems" element={<ProtectedRoute data-id="element-10">
                <DEMSModule data-id="element-11" />
              </ProtectedRoute>} data-id="element-9" />
          <Route path="/de" element={<ProtectedRoute data-id="element-13">
                <DataEnrichmentModule data-id="element-14" />
              </ProtectedRoute>} data-id="element-12" />
          <Route path="/cron" element={<ProtectedRoute data-id="element-16">
                <CRONModule data-id="element-17" />
              </ProtectedRoute>} data-id="element-15" />
          <Route path="*" element={<Navigate to="/login" data-id="element-19" />} data-id="element-18" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}